import * as React from "react";
const SvgFiRrBahai = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-bahai_svg__a)">
      <path
        fill="#062147"
        d="M23.968 10.23a2.06 2.06 0 0 0-1.288-1.573l-2.56-1.004.411-2.72a2.06 2.06 0 0 0-.719-1.903 2.07 2.07 0 0 0-1.999-.377l-2.606.878-1.433-2.349c-.744-1.312-2.804-1.312-3.548 0L8.793 3.53l-2.606-.877a2.07 2.07 0 0 0-1.999.376 2.06 2.06 0 0 0-.719 1.903l.412 2.72-2.56 1.003a2.06 2.06 0 0 0-1.289 1.573 2.07 2.07 0 0 0 .672 1.921l2.062 1.82-1.316 2.413c-.35.641-.34 1.401.025 2.033a2.06 2.06 0 0 0 1.75 1.04l2.75.066.542 2.694c.144.716.64 1.292 1.325 1.542a2.06 2.06 0 0 0 2.01-.328L12 21.713l2.15 1.717a2.06 2.06 0 0 0 2.007.327 2.06 2.06 0 0 0 1.325-1.54l.543-2.696 2.75-.067a2.07 2.07 0 0 0 1.75-1.039 2.06 2.06 0 0 0 .024-2.033l-1.316-2.414 2.063-1.819a2.07 2.07 0 0 0 .671-1.92zm-4.656 2.767a1 1 0 0 0-.217 1.23l1.698 3.114-.066.115-3.547.087a1 1 0 0 0-.956.802l-.702 3.478-.125.047-2.773-2.214a1 1 0 0 0-1.248 0L8.603 21.87l-.125-.047-.702-3.478a1 1 0 0 0-.956-.802l-3.547-.087-.066-.115 1.698-3.115a1 1 0 0 0-.217-1.229L2.026 10.65l.023-.132 3.304-1.295a1 1 0 0 0 .624-1.08l-.53-3.509.102-.085 3.363 1.132c.442.146.93-.028 1.172-.428l1.85-3.029h.133l1.85 3.03c.243.398.73.573 1.171.427l3.363-1.132.103.085-.53 3.51c-.07.461.188.91.623 1.08l3.304 1.294.023.132z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-bahai_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBahai;
